import { QuoteModal } from "@components/_subscription/enterprise-plan-card/QuoteModal"
import { Heading } from "@components/ui/typograhpy/Heading"
import { Text } from "@components/ui/typograhpy/Text"
import { cn } from "@lib/cn"
import React, { FC } from "react"

type EnterprisePlanCardProps = {
  isActivePlan?: boolean
}

export const EnterprisePlanCard: FC<EnterprisePlanCardProps> = ({
  isActivePlan = false,
}) => {
  return (
    <div
      className={cn(
        "relative rounded-md bg-border-disabled p-5 md:p-6",
        "-mt-6 mb-12 flex flex-col md:flex-row md:items-center md:justify-between md:[&>div]:max-w-[60%]",
      )}
    >
      <div>
        <Heading variant="h5" as="h2" className="inline-block">
          Enterprise
        </Heading>
        <Text variant="regular" className="mt-2 text-white">
          In need of a custom offer? Custom pricing, custom amount of credits
          and premium support for your organisation.
        </Text>
      </div>
      <QuoteModal isActivePlan={isActivePlan} />
    </div>
  )
}
